// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3o036","icon":"SortAdornment_icon__35un1","up":"SortAdornment_up__3jipd","down":"SortAdornment_down__3bCy7","active":"SortAdornment_active__3rHs1"};